module.exports = __webpack_public_path__ + "static/media/video-post-formulario.e5b9892c.mp4";